var n = (i, t, s) => new Promise((e, r) => {
  var f = (o) => {
    try {
      a(s.next(o));
    } catch (c) {
      r(c);
    }
  }, m = (o) => {
    try {
      a(s.throw(o));
    } catch (c) {
      r(c);
    }
  }, a = (o) => o.done ? e(o.value) : Promise.resolve(o.value).then(f, m);
  a((s = s.apply(i, t)).next());
});
import { selfAxios as p } from "@oppein/op-utils";
function y(i) {
  return n(this, null, function* () {
    const {
      data: t
    } = yield p.post(
      "/bsplatform/commodity/classification/dictionary/rela/codes",
      i
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  y as postCodes
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js
// module id = 222
// module chunks = 67